<template>
  <transition
    name="slide-down"
    @enter="enter"
    @leave="leave"
    @after-enter="afterEnter"
    @after-leave="afterLeave"
  >
    <slot />
  </transition>
</template>

<script setup>
const enter = (el) => {
  el.style.height = '0';
  el.style.overflow = 'hidden';
  requestAnimationFrame(() => {
    el.style.height = el.scrollHeight + 'px';
  });
};

const leave = (el) => {
  el.style.height = el.scrollHeight + 'px';
  requestAnimationFrame(() => {
    el.style.height = '0';
  });
};

const afterEnter = (el) => {
  el.style.height = 'auto';
};

const afterLeave = (el) => {
  el.style.height = '';
};
</script>
